import { css } from 'styled-components'

export default ({ h, w }) => css`
    ${h ? `height: ${h}px` : ''};
    ${w ? `width: ${w}px` : ''};
`
